var _excluded = ["data"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loadSDKVersion } from "./util.mjs";
import { configureCache, refreshFeatures, startStreaming, unsubscribe } from "./feature-repository.mjs";
import { runExperiment, evalFeature as _evalFeature, getAllStickyBucketAssignmentDocs, decryptPayload, getApiHosts as _getApiHosts } from "./core.mjs";
var SDK_VERSION = loadSDKVersion();
export var GrowthBookClient = /*#__PURE__*/function () {
  // Properties and methods that start with "_" are mangled by Terser (saves ~150 bytes)

  function GrowthBookClient(options) {
    _classCallCheck(this, GrowthBookClient);
    options = options || {};
    // These properties are all initialized in the constructor instead of above
    // This saves ~80 bytes in the final output
    this.version = SDK_VERSION;
    this._options = options;
    this.debug = !!options.debug;
    this.ready = false;
    this._features = {};
    this._experiments = [];
    this.log = this.log.bind(this);
  }
  return _createClass(GrowthBookClient, [{
    key: "setPayload",
    value: function () {
      var _setPayload = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this._payload = payload;
              _context.next = 3;
              return decryptPayload(payload, this._options.decryptionKey);
            case 3:
              data = _context.sent;
              this._decryptedPayload = data;
              if (data.features) {
                this._features = data.features;
              }
              if (data.experiments) {
                this._experiments = data.experiments;
              }
              if (data.savedGroups) {
                this._options.savedGroups = data.savedGroups;
              }
              this.ready = true;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setPayload(_x) {
        return _setPayload.apply(this, arguments);
      }
      return setPayload;
    }()
  }, {
    key: "initSync",
    value: function initSync(options) {
      var payload = options.payload;
      if (payload.encryptedExperiments || payload.encryptedFeatures) {
        throw new Error("initSync does not support encrypted payloads");
      }
      this._payload = payload;
      this._decryptedPayload = payload;
      if (payload.features) {
        this._features = payload.features;
      }
      if (payload.experiments) {
        this._experiments = payload.experiments;
      }
      this.ready = true;
      startStreaming(this, options);
      return this;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
        var _yield$this$_refresh, data, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = options || {};
              if (options.cacheSettings) {
                configureCache(options.cacheSettings);
              }
              if (!options.payload) {
                _context2.next = 9;
                break;
              }
              _context2.next = 5;
              return this.setPayload(options.payload);
            case 5:
              startStreaming(this, options);
              return _context2.abrupt("return", {
                success: true,
                source: "init"
              });
            case 9:
              _context2.next = 11;
              return this._refresh(_objectSpread(_objectSpread({}, options), {}, {
                allowStale: true
              }));
            case 11:
              _yield$this$_refresh = _context2.sent;
              data = _yield$this$_refresh.data;
              res = _objectWithoutProperties(_yield$this$_refresh, _excluded);
              startStreaming(this, options);
              _context2.next = 17;
              return this.setPayload(data || {});
            case 17:
              return _context2.abrupt("return", res);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function init(_x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "refreshFeatures",
    value: function () {
      var _refreshFeatures = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(options) {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this._refresh(_objectSpread(_objectSpread({}, options || {}), {}, {
                allowStale: false
              }));
            case 2:
              res = _context3.sent;
              if (!res.data) {
                _context3.next = 6;
                break;
              }
              _context3.next = 6;
              return this.setPayload(res.data);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function refreshFeatures(_x3) {
        return _refreshFeatures.apply(this, arguments);
      }
      return refreshFeatures;
    }()
  }, {
    key: "getApiInfo",
    value: function getApiInfo() {
      return [this.getApiHosts().apiHost, this.getClientKey()];
    }
  }, {
    key: "getApiHosts",
    value: function getApiHosts() {
      return _getApiHosts(this._options);
    }
  }, {
    key: "getClientKey",
    value: function getClientKey() {
      return this._options.clientKey || "";
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      return this._payload || {
        features: this.getFeatures(),
        experiments: this._experiments || []
      };
    }
  }, {
    key: "getDecryptedPayload",
    value: function getDecryptedPayload() {
      return this._decryptedPayload || this.getPayload();
    }
  }, {
    key: "_refresh",
    value: function () {
      var _refresh2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref) {
        var timeout, skipCache, allowStale, streaming;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              timeout = _ref.timeout, skipCache = _ref.skipCache, allowStale = _ref.allowStale, streaming = _ref.streaming;
              if (this._options.clientKey) {
                _context4.next = 3;
                break;
              }
              throw new Error("Missing clientKey");
            case 3:
              return _context4.abrupt("return", refreshFeatures({
                instance: this,
                timeout: timeout,
                skipCache: skipCache || this._options.disableCache,
                allowStale: allowStale,
                backgroundSync: streaming !== null && streaming !== void 0 ? streaming : true
              }));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function _refresh(_x4) {
        return _refresh2.apply(this, arguments);
      }
      return _refresh;
    }()
  }, {
    key: "getFeatures",
    value: function getFeatures() {
      return this._features || {};
    }
  }, {
    key: "getGlobalAttributes",
    value: function getGlobalAttributes() {
      return this._options.globalAttributes || {};
    }
  }, {
    key: "setGlobalAttributes",
    value: function setGlobalAttributes(attributes) {
      this._options.globalAttributes = attributes;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      unsubscribe(this);

      // Release references to save memory
      this._features = {};
      this._experiments = [];
      this._decryptedPayload = undefined;
      this._payload = undefined;
      this._options = {};
    }
  }, {
    key: "runInlineExperiment",
    value: function runInlineExperiment(experiment, userContext) {
      var _runExperiment = runExperiment(experiment, null, this._getEvalContext(userContext)),
        result = _runExperiment.result;
      return result;
    }
  }, {
    key: "_getEvalContext",
    value: function _getEvalContext(userContext) {
      if (this._options.globalAttributes) {
        userContext = _objectSpread(_objectSpread({}, userContext), {}, {
          attributes: _objectSpread(_objectSpread({}, this._options.globalAttributes), userContext.attributes)
        });
      }
      return {
        user: userContext,
        global: this._getGlobalContext(),
        stack: {
          evaluatedFeatures: new Set()
        }
      };
    }
  }, {
    key: "_getGlobalContext",
    value: function _getGlobalContext() {
      return {
        features: this._features,
        experiments: this._experiments,
        log: this.log,
        enabled: this._options.enabled,
        qaMode: this._options.qaMode,
        savedGroups: this._options.savedGroups,
        forcedFeatureValues: this._options.forcedFeatureValues,
        forcedVariations: this._options.forcedVariations,
        trackingCallback: this._options.trackingCallback,
        onFeatureUsage: this._options.onFeatureUsage
      };
    }
  }, {
    key: "isOn",
    value: function isOn(key, userContext) {
      return this.evalFeature(key, userContext).on;
    }
  }, {
    key: "isOff",
    value: function isOff(key, userContext) {
      return this.evalFeature(key, userContext).off;
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue, userContext) {
      var value = this.evalFeature(key, userContext).value;
      return value === null ? defaultValue : value;
    }
  }, {
    key: "evalFeature",
    value: function evalFeature(id, userContext) {
      return _evalFeature(id, this._getEvalContext(userContext));
    }
  }, {
    key: "log",
    value: function log(msg, ctx) {
      if (!this.debug) return;
      if (this._options.log) this._options.log(msg, ctx);else console.log(msg, ctx);
    }
  }, {
    key: "setTrackingCallback",
    value: function setTrackingCallback(callback) {
      this._options.trackingCallback = callback;
    }
  }, {
    key: "applyStickyBuckets",
    value: function () {
      var _applyStickyBuckets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(partialContext, stickyBucketService) {
        var ctx, stickyBucketAssignmentDocs, userContext;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              ctx = this._getEvalContext(partialContext);
              _context5.next = 3;
              return getAllStickyBucketAssignmentDocs(ctx, stickyBucketService);
            case 3:
              stickyBucketAssignmentDocs = _context5.sent;
              userContext = _objectSpread(_objectSpread({}, partialContext), {}, {
                stickyBucketAssignmentDocs: stickyBucketAssignmentDocs,
                saveStickyBucketAssignmentDoc: function saveStickyBucketAssignmentDoc(doc) {
                  return stickyBucketService.saveAssignments(doc);
                }
              });
              return _context5.abrupt("return", userContext);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function applyStickyBuckets(_x5, _x6) {
        return _applyStickyBuckets.apply(this, arguments);
      }
      return applyStickyBuckets;
    }()
  }, {
    key: "createScopedInstance",
    value: function createScopedInstance(userContext) {
      return new UserScopedGrowthBook(this, userContext);
    }
  }]);
}();
export var UserScopedGrowthBook = /*#__PURE__*/function () {
  function UserScopedGrowthBook(gb, userContext) {
    _classCallCheck(this, UserScopedGrowthBook);
    this._gb = gb;
    this._userContext = userContext;
  }
  return _createClass(UserScopedGrowthBook, [{
    key: "runInlineExperiment",
    value: function runInlineExperiment(experiment) {
      return this._gb.runInlineExperiment(experiment, this._userContext);
    }
  }, {
    key: "isOn",
    value: function isOn(key) {
      return this._gb.isOn(key, this._userContext);
    }
  }, {
    key: "isOff",
    value: function isOff(key) {
      return this._gb.isOff(key, this._userContext);
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue) {
      return this._gb.getFeatureValue(key, defaultValue, this._userContext);
    }
  }, {
    key: "evalFeature",
    value: function evalFeature(id) {
      return this._gb.evalFeature(id, this._userContext);
    }
  }]);
}();